"use client";

import { useContext } from "react";
import { FilterParamsContext } from "../FilterParamsProvider";
import ValueSlider from "../ValueSlider";

export const INCOME_MAX_VALUE = 300000;

export const sliderValueToFilterValue = (value: number) =>
  (value * INCOME_MAX_VALUE) / 100;

export const filterValueToSliderValue = (
  fallbackValue: number,
  value?: number,
) => {
  if (value === undefined || value === null || value === -1) {
    return fallbackValue;
  } else {
    return (value * 100) / INCOME_MAX_VALUE;
  }
};

export default function IncomeSlider({
  label,
  filterType,
}: {
  filterType: "city_income" | "county_income";
  label: string;
}) {
  const { setFilterParams, filterParams } = useContext(FilterParamsContext);

  return (
    <ValueSlider
      label={label}
      value={filterParams[filterType]}
      onChange={(newValue) =>
        setFilterParams({
          ...filterParams,
          [filterType]: newValue,
        })
      }
      sliderValueToFilterValue={sliderValueToFilterValue}
      filterValueToSliderValue={filterValueToSliderValue}
      max={INCOME_MAX_VALUE}
      prefix="$"
      minPlaceholder="0"
    />
  );
}
